/**
 * Thread-activity lever (2026-09-17): `REACT_APP_THREAD_ACTIVITY=off` removes
 * the threads · mentions · direct strip from the rail and the sheet, and with it
 * the mentions listener. The list then renders exactly as it did before.
 *
 * Default ON, deliberately. A record of who named you is only useful if it has
 * been collecting, and this platform has twice shipped a finished feature behind
 * a flag nobody flipped (`guestChat.primaryBrain`, `memory-retrieval`) and
 * watched it sit dark for days. The server's own kill switch (`ops/mentionInbox`)
 * is separate and also defaults on, so turning the UI off does not stop the
 * record accumulating — which is what makes turning it back on useful.
 */
export function threadActivityEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_THREAD_ACTIVITY ?? '').trim().toLowerCase() !== 'off';
}

/**
 * Archive-aware mentions + bell (2026-09-21):
 * `REACT_APP_THREAD_CLOSURE=off` stops every surface consulting the archive —
 * no archived-index listener, no probe, an empty closed set — and the mentions
 * list and the bell render exactly as they did before.
 *
 * Default ON, deliberately, and for a different reason than its neighbour
 * above. Archive-for-everyone shipped on 2026-08-26; a mention row into a
 * closed thread is not a new feature waiting for a decision, it is a dead end
 * that lands the person in a title-less, rail-less pane. So this lever is a
 * ROLLBACK, not a ship gate — and this platform has twice shipped finished work
 * behind a flag nobody flipped (`guestChat.primaryBrain`, `memory-retrieval`)
 * and watched it sit dark for days.
 */
export function threadClosureAwarenessEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_THREAD_CLOSURE ?? '').trim().toLowerCase() !== 'off';
}
